import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WebcamModule } from 'ngx-webcam';
import { QRCodeModule } from 'angularx-qrcode';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { CustomMaterialModuleModule } from './custom-material-module/custom-material-module.module';

//USER
import { StorageServiceModule } from 'angular-webstorage-service';

//GLOBAL FUNCTIONS
import { QuotationFunctionData } from './quotation-activity-functions';

// Settings
import { environment } from './../environments/environment';
import { RoutesDefinition } from './routes-definition';

// Cloud Firestore
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireModule } from 'angularfire2';

// Design
import { MaterializeModule } from 'angular2-materialize';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { PaginationModule, TabsModule } from 'ngx-bootstrap';
import { PdfmakeService } from 'ng-pdf-make';
import { SortablejsModule } from 'angular-sortablejs';

// General Structure
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { LoginPageComponent } from './authentication/login-page/login-page.component';

// Menu : Catalogs
import { CreateDepartmentComponent } from './departments/create-department/create-department.component';
import { ReadDepartmentComponent } from './departments/read-department/read-department.component';
import { UpdateDepartmentComponent } from './departments/update-department/update-department.component';
import { DisplayDepartmentComponent } from './departments/display-department/display-department.component';
import { CreateEmployeeComponent } from './employees/create-employee/create-employee.component';
import { ReadEmployeeComponent } from './employees/read-employee/read-employee.component';
import { UpdateEmployeeComponent } from './employees/update-employee/update-employee.component';
import { DisplayEmployeeComponent } from './employees/display-employee/display-employee.component';
import { RolesjobsComponent } from './rolesjobs/rolesjobs/rolesjobs.component';
import { CreateJobComponent } from './rolesjobs/create-job/create-job.component';
import { ReadJobComponent } from './rolesjobs/read-job/read-job.component';
import { UpdateJobComponent } from './rolesjobs/update-job/update-job.component';
import { DisplayJobComponent } from './rolesjobs/display-job/display-job.component';
import { CreateRoleComponent } from './rolesjobs/create-role/create-role.component';
import { ReadRoleComponent } from './rolesjobs/read-role/read-role.component';
import { UpdateRoleComponent } from './rolesjobs/update-role/update-role.component';
import { DisplayRoleComponent } from './rolesjobs/display-role/display-role.component';
import { CreateActivityComponent } from './activities/create-activity/create-activity.component';
import { ReadActivityComponent } from './activities/read-activity/read-activity.component';
import { UpdateActivityComponent } from './activities/update-activity/update-activity.component';
import { DisplayActivityComponent } from './activities/display-activity/display-activity.component';
import { CreateWorkShiftComponent } from './work-shifts/create-work-shift/create-work-shift.component';
import { ReadWorkShiftComponent } from './work-shifts/read-work-shift/read-work-shift.component';
import { UpdateWorkShiftComponent } from './work-shifts/update-work-shift/update-work-shift.component';
import { DisplayWorkShiftComponent } from './work-shifts/display-work-shift/display-work-shift.component';
import { CreateGroupComponent } from './groups/create-group/create-group.component';
import { ReadGroupComponent } from './groups/read-group/read-group.component';
import { UpdateGroupComponent } from './groups/update-group/update-group.component';
import { DisplayGroupComponent } from './groups/display-group/display-group.component';
import { CreateUserComponent } from './users/create-user/create-user.component';
import { ReadUserComponent } from './users/read-user/read-user.component';
import { UpdateUserComponent } from './users/update-user/update-user.component';
import { DisplayUserComponent } from './users/display-user/display-user.component';
import { DisplayPermissionComponent } from './permissions/display-permission/display-permission.component';
import { SpecialPermissionsComponent } from './permissions/special-permissions/special-permissions.component';
import { SettingsComponent } from './catalogs/settings/settings.component';

// Menu : Payroll
import { CreateCheckClockComponent } from './check-clock/create-check-clock/create-check-clock.component';
import { ReadCheckClockComponent } from './check-clock/read-check-clock/read-check-clock.component';
import { DisplayCheckClockComponent } from './check-clock/display-check-clock/display-check-clock.component';
import { ReadRegisteredEmployeesComponent } from './check-clock/read-registered-employees/read-registered-employees.component';
import { CreateUnregisteredEmployeeComponent } from './check-clock/create-unregistered-employee/create-unregistered-employee.component';
import { ReadUnregisteredEmployeesComponent } from './check-clock/read-unregistered-employees/read-unregistered-employees.component';
import { CreateSupervisorReportComponent } from './supervisor-reports/create-supervisor-report/create-supervisor-report.component';
import { ReadSupervisorReportComponent } from './supervisor-reports/read-supervisor-report/read-supervisor-report.component';
import { UpdateSupervisorReportComponent } from './supervisor-reports/update-supervisor-report/update-supervisor-report.component';
import { DisplaySupervisorReportComponent } from './supervisor-reports/display-supervisor-report/display-supervisor-report.component';
import { CreateCarrierReportComponent } from './carrier-reports/create-carrier-report/create-carrier-report.component';
import { ReadCarrierReportComponent } from './carrier-reports/read-carrier-report/read-carrier-report.component';
import { UpdateCarrierReportComponent } from './carrier-reports/update-carrier-report/update-carrier-report.component';
import { DisplayCarrierReportComponent } from './carrier-reports/display-carrier-report/display-carrier-report.component';
import { CreatePrompterReportComponent } from './prompter-reports/create-prompter-report/create-prompter-report.component';
import { ReadPrompterReportComponent } from './prompter-reports/read-prompter-report/read-prompter-report.component';
import { UpdatePrompterReportComponent } from './prompter-reports/update-prompter-report/update-prompter-report.component';
import { DisplayPrompterReportComponent } from './prompter-reports/display-prompter-report/display-prompter-report.component';
import { CreateOvertimeComponent } from './overtimes/create-overtime/create-overtime.component';
import { ReadOvertimeComponent } from './overtimes/read-overtime/read-overtime.component';
import { UpdateOvertimeComponent } from './overtimes/update-overtime/update-overtime.component';
import { DisplayOvertimeComponent } from './overtimes/display-overtime/display-overtime.component';
import { DisplayAssistanceReportComponent } from './assistance-report/display-assistance-report/display-assistance-report.component';
import { DisplayAssistanceComponent } from './assistance/display-assistance/display-assistance.component';
import { DisplayPayrollEstimateComponent } from './payroll-estimate/display-payroll-estimate/display-payroll-estimate.component';
import { CreateLoanComponent } from './loans/create-loan/create-loan.component';
import { ReadLoanComponent } from './loans/read-loan/read-loan.component';
import { UpdateLoanComponent } from './loans/update-loan/update-loan.component';
import { DisplayLoanComponent } from './loans/display-loan/display-loan.component';

// Menu : Sales
import { CreateCustomerComponent } from './customers/create-customer/create-customer.component';
import { ReadCustomerComponent } from './customers/read-customer/read-customer.component';
import { UpdateCustomerComponent } from './customers/update-customer/update-customer.component';
import { DisplayCustomerComponent } from './customers/display-customer/display-customer.component';
import { CreateAddressComponent } from './addresses/create-address/create-address.component';
import { ReadAddressComponent } from './addresses/read-address/read-address.component';
import { UpdateAddressComponent } from './addresses/update-address/update-address.component';
import { DisplayAddressComponent } from './addresses/display-address/display-address.component';

// Menu : Purchases
import { CreateSupplierComponent } from './suppliers/create-supplier/create-supplier.component';
import { ReadSupplierComponent } from './suppliers/read-supplier/read-supplier.component';
import { UpdateSupplierComponent } from './suppliers/update-supplier/update-supplier.component';
import { DisplaySupplierComponent } from './suppliers/display-supplier/display-supplier.component';
import { CreateShipComponent } from './ships/create-ship/create-ship.component';
import { UpdateShipComponent } from './ships/update-ship/update-ship.component';
import { DeleteShipComponent } from './ships/delete-ship/delete-ship.component';
import { ReadShipComponent } from './ships/read-ship/read-ship.component';

// Menu : Production
import { CreateProductionOrderComponent } from './production-order/create-production-order/create-production-order.component';
import { ReadProductionOrderComponent } from './production-order/read-production-order/read-production-order.component';
import { UpdateProductionOrderComponent } from './production-order/update-production-order/update-production-order.component';
import { DisplayProductionOrderComponent } from './production-order/display-production-order/display-production-order.component';
import { OdpPriorityComponent } from './production-order/odp-priority/odp-priority.component';

// Pending to refactor :::
import { CreateSubsidiaryComponent } from './subsidiaries/create-subsidiary/create-subsidiary.component';
import { ReadSubsidiaryComponent } from './subsidiaries/read-subsidiary/read-subsidiary.component';
import { UpdateSubsidiaryComponent } from './subsidiaries/update-subsidiary/update-subsidiary.component';

// Services
import { FirestoreService } from './services/firestore/firestore.service';
import { UploadService } from './services/upload/upload.service';
import { CompanyService, CompanyData } from './services/company.service';
import { ActivityService } from './services/activity.service';
import { ActivityClassificationService } from './services/activity-classification.service';
import { AddressService } from './services/address.service';
import { ApprovedAssistanceService } from './services/approved-assistance.service';
import { AssistanceService } from './services/assistance.service';
import { AssistanceReportService } from './services/assistance-report.service';
import { AuthService } from './services/auth.service';
import { CarrierReportService } from './services/carrier-report.service';
import { CatalogsSettingsService } from './services/catalogs-settings.service';
import { CheckClockService } from './services/check-clock.service';
import { CheckClockLoadService } from './services/check-clock-load.service';
import { CountryService } from './services/country.service';
import { CustomerSupplierService } from './services/customer-supplier.service';
import { CustomerSupplierTypeService } from './services/customer-supplier-type.service';
import { DepartmentService } from './services/department.service';
import { EmployeeService } from './services/employee.service';
import { FiscalDataService } from './services/fiscal-data.service';
import { KeyPersonsService } from './services/key-persons.service';
import { GroupService } from './services/group.service';
import { GuardService } from './services/guard.service';
import { JobService } from './services/job.service';
import { LoanService } from './services/loan.service';
import { LogService } from './services/log.service';
import { MeasurementUnitService } from './services/measurement-unit.service';
import { OvertimeService } from './services/overtime.service';
import { PayrollService } from './services/payroll.service';
import { PermissionService } from './services/permission.service';
import { ProductionOrderService, ProductionOrderData } from './services/production-order.service';
import { ProductCmpaService } from './services/product-cmpa.service';
import { ProductTypeService } from './services/product-type.service';
import { PrTypeData } from './services/product-type.service';
import { ProductVntaService, PrVntaData } from './services/product-vnta.service';
import { PrompterReportService } from './services/prompter-report.service';
import { RoleService } from './services/role.service';
import { ShipService } from './services/ship.service';
import { StateService } from './services/state.service';
import { SupervisorReportService } from './services/supervisor-report.service';
import { UnitService } from './services/unit.service';
import { UserService } from './services/user.service';
import { PurchaseOrderService } from './services/purchase-order.service';
import { PurchaseRequestService } from './services/purchase-request.service';
import { InAndOutService } from './services/in-and-out.service';
import { WarehouseService } from './services/warehouse.service';
import { TranService } from './services/tran.service';
import { StockService } from './services/stock.service';
import { ConstantCostsService } from './services/constant-costs.service';
import { WorkShiftService } from './services/work-shift.service';
import { ProductClientService, PrClientData } from './services/product-client.service';
import { QuotService } from './services/quot.service';
import { BankService, BankData } from './services/bank.service';
import { LiftOrderService } from './services/lift-order.service';
import { SupplierBillService, SupplierBillData } from './services/supplier-bill.service';
import { CustomerBillService, CustomerBillData } from './services/customer-bill.service';
import { RemissionService, RemissionData } from './services/remission.service';
import { IncomeService, IncomeData } from './services/income.service';
import { OutcomeService, OutcomeData } from './services/outcome.service';
import { SuajeService } from './services/suaje.service';
import { DefectService } from './services/defect.service';
import { MachineService } from './services/machine.service';
import { ExpenseCategoryService } from './services/expense-category.service';
import { ExpenseConceptService } from './services/expense-concept.service';
import { StudentService, StudentData } from './services/student.service';
import { ParentService, ParentData } from './services/parent.service';
import { TeacherService, TeacherData } from './services/teacher.service';
import { SecurityReportService } from './services/security-report.service';
import { NewPrompterReportService } from './services/new-prompter-report.service';
import { AutoService } from './services/auto.service';

// Pending to refactor :::
import { HttpRequestService } from './services/http-request.service';
import { ActivitiesService } from './services/activities.service';
import { SubsidiaryService } from './services/subsidiary.service';

// Components
import { ReadUnitComponent } from './units/read-unit/read-unit.component';
import { CreateUnitComponent } from './units/create-unit/create-unit.component';
import { UpdateUnitComponent } from './units/update-unit/update-unit.component';
import { ReadPrTypeComponent } from './pr-types/read-pr-type/read-pr-type.component';
import { CreatePrTypeComponent } from './pr-types/create-pr-type/create-pr-type.component';
import { UpdatePrTypeComponent } from './pr-types/update-pr-type/update-pr-type.component';
import { CreatePrCTypeComponent } from './pr-c-types/create-pr-c-type/create-pr-c-type.component';
import { ReadPrCTypeComponent } from './pr-c-types/read-pr-c-type/read-pr-c-type.component';
import { UpdatePrCTypeComponent } from './pr-c-types/update-pr-c-type/update-pr-c-type.component';
import { CreatePrVntaComponent } from './pr-vnta/create-pr-vnta/create-pr-vnta.component';
import { ReadPrVntaComponent } from './pr-vnta/read-pr-vnta/read-pr-vnta.component';
import { UpdatePrVntaComponent } from './pr-vnta/update-pr-vnta/update-pr-vnta.component';
import { DisplayPrVntaComponent } from './pr-vnta/display-pr-vnta/display-pr-vnta.component';
import { CreatePrCmpaComponent } from './pr-cmpa/create-pr-cmpa/create-pr-cmpa.component';
import { DisplayPrCmpaComponent } from './pr-cmpa/display-pr-cmpa/display-pr-cmpa.component';
import { ReadPrCmpaComponent } from './pr-cmpa/read-pr-cmpa/read-pr-cmpa.component';
import { UpdatePrCmpaComponent } from './pr-cmpa/update-pr-cmpa/update-pr-cmpa.component';
import { CreatePurchaseOrderComponent } from './purchase-order/create-purchase-order/create-purchase-order.component';
import { ReadPurchaseOrderComponent } from './purchase-order/read-purchase-order/read-purchase-order.component';
import { DisplayPurchaseOrderComponent } from './purchase-order/display-purchase-order/display-purchase-order.component';
import { UpdatePurchaseOrderComponent } from './purchase-order/update-purchase-order/update-purchase-order.component';
import { ReadInAndOutComponent } from './in-and-out/read-in-and-out/read-in-and-out.component';
import { CreateInAndOutComponent } from './in-and-out/create-in-and-out/create-in-and-out.component';
import { UpdateInAndOutComponent } from './in-and-out/update-in-and-out/update-in-and-out.component';
import { CreateWarehouseComponent } from './warehouse/create-warehouse/create-warehouse.component';
import { ReadWarehouseComponent } from './warehouse/read-warehouse/read-warehouse.component';
import { UpdateWarehouseComponent } from './warehouse/update-warehouse/update-warehouse.component';
import { ReadInTranComponent } from './tran/read-in-tran/read-in-tran.component';
import { CreateInTranComponent } from './tran/create-in-tran/create-in-tran.component';
import { CreateOutTranComponent } from './tran/create-out-tran/create-out-tran.component';
import { DisplayTranComponent } from './tran/display-tran/display-tran.component';

import { ViewCompanyComponent } from './companies/view-company/view-company.component';
import { UpdateCompanyComponent } from './companies/update-company/update-company.component';
import { ReadOutTranComponent } from './tran/read-out-tran/read-out-tran.component';
import * as moment from 'moment';
import { ReadStockPiecesComponent } from './stock/read-stock-pieces/read-stock-pieces.component';
import { ProductStockComponent } from './stock/product-stock/product-stock.component';
import { ReadConstantCostsComponent } from './costs/read-constant-costs/read-constant-costs.component';
import { CreateConstantCostsComponent } from './costs/create-constant-costs/create-constant-costs.component';
import { UpdateConstantCostsComponent } from './costs/update-constant-costs/update-constant-costs.component';
import { ReadFiscalDataComponent } from './fiscal-data/read-fiscal-data/read-fiscal-data.component';
import { CreateFiscalDataComponent } from './fiscal-data/create-fiscal-data/create-fiscal-data.component';
import { DisplayFiscalDataComponent } from './fiscal-data/display-fiscal-data/display-fiscal-data.component';
import { UpdateFiscalDataComponent } from './fiscal-data/update-fiscal-data/update-fiscal-data.component';
import { ReadKeyPersonsComponent } from './key-persons/read-key-persons/read-key-persons.component';
import { CreateKeyPersonsComponent } from './key-persons/create-key-persons/create-key-persons.component';
import { UpdateKeyPersonsComponent } from './key-persons/update-key-persons/update-key-persons.component';
import { DisplayKeyPersonsComponent } from './key-persons/display-key-persons/display-key-persons.component';
import { ReadPurchaseRequestComponent } from './purchase-request/read-purchase-request/read-purchase-request.component';
import { CreatePurchaseRequestComponent } from './purchase-request/create-purchase-request/create-purchase-request.component';
import { DisplayPurchaseRequestComponent } from './purchase-request/display-purchase-request/display-purchase-request.component';
import { UpdatePurchaseRequestComponent } from './purchase-request/update-purchase-request/update-purchase-request.component';
import { OrderPurchaseRequestComponent } from './purchase-request/order-purchase-request/order-purchase-request.component';
import { DisplayDocumentsTypesComponent } from './documents-types/display-documents-types/display-documents-types.component';
import { CreateDocumentsTypesComponent } from './documents-types/create-documents-types/create-documents-types.component';
import { DocumentsTypesService } from './services/documents-types.service';
import { CreateActivityClassificationComponent } from './activity-classification/create-activity-classification/create-activity-classification.component';
import { ReadActivityClassificationComponent } from './activity-classification/read-activity-classification/read-activity-classification.component';
import { UpdateActivityClassificationComponent } from './activity-classification/update-activity-classification/update-activity-classification.component';
import { CreatePrClientComponent } from './pr-client/create-pr-client/create-pr-client.component';
import { DisplayPrClientComponent } from './pr-client/display-pr-client/display-pr-client.component';
import { ReadPrClientComponent } from './pr-client/read-pr-client/read-pr-client.component';
import { UpdatePrClientComponent } from './pr-client/update-pr-client/update-pr-client.component';
import { CreateQuotComponent } from './quot/create-quot/create-quot.component';
import { ReadQuotComponent } from './quot/read-quot/read-quot.component';
import { DisplayQuotComponent } from './quot/display-quot/display-quot.component';
import { UpdateQuotComponent } from './quot/update-quot/update-quot.component';
import { CreateBankComponent } from './banks/create-bank/create-bank.component';
import { ReadBankComponent } from './banks/read-bank/read-bank.component';
import { UpdateBankComponent } from './banks/update-bank/update-bank.component';
import { DisplayBankComponent } from './banks/display-bank/display-bank.component';
import { CreateLiftOrderComponent } from './liftOrders/create-lift-order/create-lift-order.component';
import { ReadLiftOrderComponent } from './liftOrders/read-lift-order/read-lift-order.component';
import { UpdateLiftOrderComponent } from './liftOrders/update-lift-order/update-lift-order.component';
import { DisplayLiftOrderComponent } from './liftOrders/display-lift-order/display-lift-order.component';
import { CreateSupplierBillComponent } from './supplierBills/create-supplier-bill/create-supplier-bill.component';
import { ReadSupplierBillComponent } from './supplierBills/read-supplier-bill/read-supplier-bill.component';
import { UpdateSupplierBillComponent } from './supplierBills/update-supplier-bill/update-supplier-bill.component';
import { DisplaySupplierBillComponent } from './supplierBills/display-supplier-bill/display-supplier-bill.component';
import { CreateRemissionComponent } from './remissions/create-remission/create-remission.component';
import { ReadRemissionComponent } from './remissions/read-remission/read-remission.component';
import { UpdateRemissionComponent } from './remissions/update-remission/update-remission.component';
import { DisplayRemissionComponent } from './remissions/display-remission/display-remission.component';
import { CertificateComponent } from './remissions/certificate/certificate.component';
import { CreateCustomerBillComponent } from './customerBills/create-customer-bill/create-customer-bill.component';
import { ReadCustomerBillComponent } from './customerBills/read-customer-bill/read-customer-bill.component';
import { UpdateCustomerBillComponent } from './customerBills/update-customer-bill/update-customer-bill.component';
import { DisplayCustomerBillComponent } from './customerBills/display-customer-bill/display-customer-bill.component';
import { CreateIncomeComponent } from './incomes/create-income/create-income.component';
import { ReadIncomeComponent } from './incomes/read-income/read-income.component';
import { UpdateIncomeComponent } from './incomes/update-income/update-income.component';
import { DisplayIncomeComponent } from './incomes/display-income/display-income.component';
import { CreateOutcomeComponent } from './outcomes/create-outcome/create-outcome.component';
import { ReadOutcomeComponent } from './outcomes/read-outcome/read-outcome.component';
import { UpdateOutcomeComponent } from './outcomes/update-outcome/update-outcome.component';
import { DisplayOutcomeComponent } from './outcomes/display-outcome/display-outcome.component';
import { ReadExpirationComponent } from './customerBills/read-expiration/read-expiration.component';
import { ReadExpirationSupplierComponent } from './supplierBills/read-expiration-supplier/read-expiration-supplier.component';
import { TransactionReportComponent } from './customers/transaction-report/transaction-report.component';
import { TransactionReportSupplierComponent } from './suppliers/transaction-report-supplier/transaction-report-supplier.component';
import { CreateSuajeComponent } from './suajes/create-suaje/create-suaje.component';
import { ReadSuajeComponent } from './suajes/read-suaje/read-suaje.component';
import { UpdateSuajeComponent } from './suajes/update-suaje/update-suaje.component';
import { DisplaySuajeComponent } from './suajes/display-suaje/display-suaje.component';
import { CreateMachineComponent } from './machines/create-machine/create-machine.component';
import { ReadMachineComponent } from './machines/read-machine/read-machine.component';
import { DisplayMachineComponent } from './machines/display-machine/display-machine.component';
import { UpdateMachineComponent } from './machines/update-machine/update-machine.component';
import { PurchaseReportComponent } from './purchase-order/purchase-report/purchase-report.component';
import { StockMinimalComponent } from './stock/stock-minimal/stock-minimal.component';
import { RentabilityReportComponent } from './reports/rentability-report/rentability-report.component';
import { BillReportDetailComponent } from './customerBills/bill-report-detail/bill-report-detail.component';
import { YearlyReportComponent } from './reports/yearly-report/yearly-report.component';
import { CreateStudentComponent } from './students/create-student/create-student.component';
import { UpdateStudentComponent } from './students/update-student/update-student.component';
import { ReadStudentComponent } from './students/read-student/read-student.component';
import { DisplayStudentComponent } from './students/display-student/display-student.component';

import { CreateParentComponent } from './parents/create-parent/create-parent.component';
import { UpdateParentComponent } from './parents/update-parent/update-parent.component';
import { ReadParentComponent } from './parents/read-parent/read-parent.component';
import { DisplayParentComponent } from './parents/display-parent/display-parent.component';

import { CreateTeacherComponent } from './teacher/create-teacher/create-teacher.component';
import { UpdateTeacherComponent } from './teacher/update-teacher/update-teacher.component';
import { ReadTeacherComponent } from './teacher/read-teacher/read-teacher.component';
import { DisplayTeacherComponent } from './teacher/display-teacher/display-teacher.component';
import { ThemeComponent } from './theme/theme.component';
import { ReadAllTranComponent } from './tran/read-all-tran/read-all-tran.component';
import { ReadStockCostsComponent } from './stock/read-stock-costs/read-stock-costs.component';
import { CreateSecurityReportComponent } from './security-report/create-security-report/create-security-report.component';
import { DisplaySecurityReportComponent } from './security-report/display-security-report/display-security-report.component';
import { ReadSecurityReportComponent } from './security-report/read-security-report/read-security-report.component';
import { UpdateSecurityReportComponent } from './security-report/update-security-report/update-security-report.component';
import { CreateNewPrompterReportComponent } from './new-prompter-report/create-new-prompter-report/create-new-prompter-report.component';
import { DisplayNewPrompterReportComponent } from './new-prompter-report/display-new-prompter-report/display-new-prompter-report.component';
import { ReadNewPrompterReportComponent } from './new-prompter-report/read-new-prompter-report/read-new-prompter-report.component';
import { UpdateNewPrompterReportComponent } from './new-prompter-report/update-new-prompter-report/update-new-prompter-report.component';
import { CrudAutoComponent } from './auto/crud-auto/crud-auto.component';
import { SuperadminComponent } from './sudo/superadmin/superadmin.component';
import { OdpLiteSearchComponent } from './production-order/odp-lite-search/odp-lite-search.component';
import { AutocompleteComponent } from './coms/autocomplete/autocomplete.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    LoginPageComponent,
    CreateDepartmentComponent, ReadDepartmentComponent, UpdateDepartmentComponent, DisplayDepartmentComponent,
    CreateEmployeeComponent, ReadEmployeeComponent, UpdateEmployeeComponent, DisplayEmployeeComponent,
    RolesjobsComponent,
    CreateJobComponent, ReadJobComponent, UpdateJobComponent, DisplayJobComponent,
    CreateRoleComponent, ReadRoleComponent, UpdateRoleComponent, DisplayRoleComponent,
    CreateActivityComponent, ReadActivityComponent, UpdateActivityComponent, DisplayActivityComponent,
    CreateWorkShiftComponent, ReadWorkShiftComponent, UpdateWorkShiftComponent, DisplayWorkShiftComponent,
    CreateGroupComponent, ReadGroupComponent, UpdateGroupComponent, DisplayGroupComponent,
    CreateUserComponent, ReadUserComponent, UpdateUserComponent, DisplayUserComponent,
    DisplayPermissionComponent, SpecialPermissionsComponent,
    SettingsComponent,
    CreateCheckClockComponent, ReadCheckClockComponent, DisplayCheckClockComponent,
    ReadRegisteredEmployeesComponent, CreateUnregisteredEmployeeComponent, ReadUnregisteredEmployeesComponent,
    CreateSupervisorReportComponent, ReadSupervisorReportComponent, UpdateSupervisorReportComponent, DisplaySupervisorReportComponent,
    CreateCarrierReportComponent, ReadCarrierReportComponent, UpdateCarrierReportComponent, DisplayCarrierReportComponent,
    CreatePrompterReportComponent, ReadPrompterReportComponent, UpdatePrompterReportComponent, DisplayPrompterReportComponent,
    CreateOvertimeComponent, ReadOvertimeComponent, UpdateOvertimeComponent, DisplayOvertimeComponent,
    DisplayAssistanceReportComponent,
    DisplayAssistanceComponent,
    DisplayPayrollEstimateComponent,
    CreateLoanComponent, ReadLoanComponent, UpdateLoanComponent, DisplayLoanComponent,
    CreateCustomerComponent, ReadCustomerComponent, UpdateCustomerComponent, DisplayCustomerComponent, TransactionReportComponent,
    CreateAddressComponent, ReadAddressComponent, UpdateAddressComponent, DisplayAddressComponent,
    CreateSupplierComponent, ReadSupplierComponent, UpdateSupplierComponent, DisplaySupplierComponent, TransactionReportSupplierComponent,
    CreateProductionOrderComponent, ReadProductionOrderComponent, UpdateProductionOrderComponent, DisplayProductionOrderComponent, OdpPriorityComponent,
    CreateSubsidiaryComponent, ReadSubsidiaryComponent, UpdateSubsidiaryComponent,
    CreateShipComponent, UpdateShipComponent, DeleteShipComponent, ReadShipComponent,
    ReadUnitComponent, CreateUnitComponent, UpdateUnitComponent,
    ReadPrTypeComponent, CreatePrTypeComponent, UpdatePrTypeComponent,
    CreatePrCTypeComponent, ReadPrCTypeComponent, UpdatePrCTypeComponent,
    CreatePrVntaComponent, ReadPrVntaComponent, UpdatePrVntaComponent, DisplayPrVntaComponent,
    CreatePrCmpaComponent, DisplayPrCmpaComponent, ReadPrCmpaComponent, UpdatePrCmpaComponent,
    CreatePurchaseOrderComponent, ReadPurchaseOrderComponent, DisplayPurchaseOrderComponent, UpdatePurchaseOrderComponent, PurchaseReportComponent,
    ReadPurchaseRequestComponent, CreatePurchaseRequestComponent, DisplayPurchaseRequestComponent, UpdatePurchaseRequestComponent, OrderPurchaseRequestComponent,
    ReadInAndOutComponent, CreateInAndOutComponent, UpdateInAndOutComponent,
    CreateWarehouseComponent, ReadWarehouseComponent, UpdateWarehouseComponent,
    ReadInTranComponent, CreateInTranComponent,
    CreateOutTranComponent, ReadOutTranComponent, DisplayTranComponent,
    ReadStockPiecesComponent,
    ReadConstantCostsComponent, CreateConstantCostsComponent, UpdateConstantCostsComponent,
    ViewCompanyComponent, UpdateCompanyComponent,
    ProductStockComponent,
    ReadConstantCostsComponent, CreateConstantCostsComponent, UpdateConstantCostsComponent,
    ReadFiscalDataComponent, CreateFiscalDataComponent, DisplayFiscalDataComponent, UpdateFiscalDataComponent,
    ReadKeyPersonsComponent, CreateKeyPersonsComponent, UpdateKeyPersonsComponent, DisplayKeyPersonsComponent,
    DisplayDocumentsTypesComponent,
    CreateDocumentsTypesComponent,
    CreateActivityClassificationComponent, ReadActivityClassificationComponent, UpdateActivityClassificationComponent,
    CreatePrClientComponent, DisplayPrClientComponent, ReadPrClientComponent, UpdatePrClientComponent,
    CreateQuotComponent, ReadQuotComponent, DisplayQuotComponent, UpdateQuotComponent,
    CreateBankComponent, ReadBankComponent, UpdateBankComponent, DisplayBankComponent,
    CreateLiftOrderComponent, ReadLiftOrderComponent, UpdateLiftOrderComponent, DisplayLiftOrderComponent,
    CreateSupplierBillComponent, ReadSupplierBillComponent, UpdateSupplierBillComponent, DisplaySupplierBillComponent, ReadExpirationSupplierComponent,
    CreateRemissionComponent, ReadRemissionComponent, UpdateRemissionComponent, DisplayRemissionComponent, CertificateComponent,
    CreateCustomerBillComponent, ReadCustomerBillComponent, UpdateCustomerBillComponent, DisplayCustomerBillComponent, ReadExpirationComponent,
    CreateIncomeComponent, ReadIncomeComponent, UpdateIncomeComponent, DisplayIncomeComponent,
    CreateOutcomeComponent, ReadOutcomeComponent, UpdateOutcomeComponent, DisplayOutcomeComponent,
    CreateSuajeComponent, ReadSuajeComponent, UpdateSuajeComponent, DisplaySuajeComponent,
    CreateMachineComponent, ReadMachineComponent, DisplayMachineComponent, UpdateMachineComponent, StockMinimalComponent,
    RentabilityReportComponent,
    BillReportDetailComponent,
    YearlyReportComponent,
    CreateStudentComponent,
    UpdateStudentComponent,
    ReadStudentComponent,
    DisplayStudentComponent,
    CreateParentComponent,
    UpdateParentComponent,
    ReadParentComponent,
    DisplayParentComponent,
    CreateTeacherComponent,
    UpdateTeacherComponent,
    ReadTeacherComponent,
    DisplayTeacherComponent,
    ThemeComponent,
    ReadAllTranComponent,
    ReadStockCostsComponent,
    CreateSecurityReportComponent, DisplaySecurityReportComponent, ReadSecurityReportComponent, UpdateSecurityReportComponent,
    CreateNewPrompterReportComponent, DisplayNewPrompterReportComponent, ReadNewPrompterReportComponent, UpdateNewPrompterReportComponent, CrudAutoComponent, SuperadminComponent, OdpLiteSearchComponent, AutocompleteComponent,
  ],
  imports: [
    StorageServiceModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(environment.cloudFirestore),
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(RoutesDefinition),
    MaterializeModule,
    Ng2TableModule,
    PaginationModule.forRoot(),
    TabsModule,
    HttpClientModule,
    CustomMaterialModuleModule,
    SortablejsModule.forRoot({ animation: 150 }),
    WebcamModule,
    QRCodeModule
  ],
  providers: [
    ActivityService,
    ActivityClassificationService,
    AddressService,
    FiscalDataService,
    KeyPersonsService,
    ApprovedAssistanceService,
    AssistanceService,
    AssistanceReportService,
    AuthService,
    CarrierReportService,
    CatalogsSettingsService,
    CheckClockService,
    CheckClockLoadService,
    CountryService,
    CustomerSupplierService,
    CustomerSupplierTypeService,
    DepartmentService,
    EmployeeService,
    GroupService,
    GuardService,
    JobService,
    LoanService,
    LogService,
    MeasurementUnitService,
    OvertimeService,
    PayrollService,
    PermissionService,
    ProductionOrderService,
    ProductCmpaService,
    ProductTypeService,
    ProductVntaService,
    PrompterReportService,
    PurchaseOrderService,
    PurchaseRequestService,
    RoleService,
    ShipService,
    StateService,
    SupervisorReportService,
    UnitService,
    UserService,
    InAndOutService,
    WarehouseService,
    TranService,
    StockService,
    ConstantCostsService,
    CompanyService, CompanyData,
    WorkShiftService,
    HttpRequestService,
    ActivitiesService,
    SubsidiaryService,
    FirestoreService,
    UploadService,
    QuotService,
    BankService,
    LiftOrderService,
    SupplierBillService,
    CustomerBillService,
    IncomeService,
    OutcomeService,
    ProductClientService, PrClientData,
    PdfmakeService,
    DocumentsTypesService,
    RemissionService,
    SuajeService,
    DefectService,
    MachineService,
    ExpenseCategoryService,
    ExpenseConceptService,
    StudentService,
    ParentService,
    TeacherService,
    SecurityReportService,
    NewPrompterReportService,
    AutoService,

    QuotationFunctionData,
    BankData,
    SupplierBillData,
    CustomerBillData,
    IncomeData,
    OutcomeData,
    ProductionOrderData,
    RemissionData,
    PrVntaData,
    PrTypeData,
    StudentData,
    ParentData,
    TeacherData
  ],
  entryComponents: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    moment.locale('es');
  }
}
